import { render, staticRenderFns } from "./DashboardUserSulteng.vue?vue&type=template&id=9e1c42ba&lang=pug"
import script from "./DashboardUserSulteng.vue?vue&type=script&lang=js"
export * from "./DashboardUserSulteng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports